import React from 'react';
import AuthForm from '../forms/authForm';

function Login() {
	return <AuthForm></AuthForm>;
}

export default Login;
